import React from 'react';
import "./Input.css";
import {MdDriveFileRenameOutline} from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const Input = ({setChange, value, icon, placeholder, type, readOnly, label_text, customInputStyle, customParentStyle}, props) => {
	const {t} = useTranslation();
	return (
		<label className={`flex items-center input_container input_container_edit ${customParentStyle}`}>
			{
				readOnly
				? <input {...props} type={type ? type : "Input"} placeholder={t(placeholder)} className={`input_default input_style readonly ${customInputStyle}`} value={value} readOnly/>
				: <input {...props} type={type ? type : "Input"} placeholder={t(placeholder)} className={`input_default input_style ${customInputStyle}`} value={value} onChange={(e)=>setChange(e.target.value)}/>
			}
			{icon}
		</label>
	)
}

export default Input